import { IState } from '../../store';
import { selectIsBookingAvailable } from '../profitbaseBooking';

export const selectIsBookingEnabled = (state: IState): boolean => {
  const isAvailable = selectIsBookingAvailable(state);

  return isAvailable && state.newbuildingBooking.isEnabled;
};
